import Home from "./home/Home";
import GuestHome from "./guestHome/GuestHome";
import Login from "./login/Login";

import Renter from "./renterUrgente/Renter";
const pages = {
  Home,
  Login,

  GuestHome,
  Renter,
};
export default pages;
